import { render, staticRenderFns } from "./SliderGroup.vue?vue&type=template&id=16b5dafe&"
import script from "./SliderGroup.vue?vue&type=script&lang=js&"
export * from "./SliderGroup.vue?vue&type=script&lang=js&"
import style0 from "./SliderGroup.vue?vue&type=style&index=0&id=16b5dafe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports